import React from "react";
import { useSearchParams } from "react-router-dom";
import useAppointmentCancellation from "../../hooks/useAppointmentCancellation";
const CancelAppointment = () => {
  const [searchParams] = useSearchParams();
  const token = searchParams.get("token");

  const { loading, preview, error, success, isCancelling, cancel } =
    useAppointmentCancellation(token);

  if (loading) return <p>Loading...</p>;
  if (error) return <p style={{ color: "red" }}>{error}</p>;
  if (success) return <p style={{ color: "green" }}>{success}</p>;

  return (
    <div className="max-w-xl mx-auto p-5 bg-white shadow-lg rounded-2 mt-10">
      <div className="flex items-center justify-between border-b pb-4">
        <h2 className="text-3xl font-semibold text-gray-800">
          Appointment Confirmed
        </h2>
      </div>
      <div className="space-y-2">
        <p>
          <span className="font-medium text-gray-700">Staff:</span>{" "}
          {preview.staff}
        </p>
        <p>
          <span className="font-medium text-gray-700">Date:</span>{" "}
          {new Date(preview.date).toLocaleDateString()}
        </p>
        <p>
          <span className="font-medium text-gray-700">Time:</span>{" "}
          {preview.startAt.split(":").slice(0, 2).join(":")}
        </p>
      </div>
      <div className="bg-gray-50 p-4 rounded-lg border border-primary">
        <strong>
          Booking Reference:{" "}
          <span className="appointment-sumery-item">{preview.reference}</span>
        </strong>
      </div>
      <div className="d-flex justify-content-end gap-4 pt-4 border-t mt-6">
        {!preview.isCancelable ? (
          <p>This appointment cannot be cancelled.</p>
        ) : (
          <button
            onClick={cancel}
            disabled={isCancelling}
            className="btn btn-primary px-4 py-2 rounded-lg text-sm"
          >
            {isCancelling ? "Cancelling..." : "Confirm Cancellation"}
          </button>
        )}
      </div>
    </div>
  );
};
export default CancelAppointment;
